import { render } from "./MessagePreviewSp.vue?vue&type=template&id=4556142a&scoped=true"
import script from "./MessagePreviewSp.vue?vue&type=script&lang=js"
export * from "./MessagePreviewSp.vue?vue&type=script&lang=js"

import "./MessagePreviewSp.vue?vue&type=style&index=0&id=4556142a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4556142a"]])

export default __exports__